import { render, staticRenderFns } from "./DatatableWorks.vue?vue&type=template&id=9345c75e&scoped=true&"
import script from "./DatatableWorks.vue?vue&type=script&lang=js&"
export * from "./DatatableWorks.vue?vue&type=script&lang=js&"
import style0 from "./DatatableWorks.vue?vue&type=style&index=0&id=9345c75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9345c75e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
